import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { LakehouseLocation } from 'app/model/dataset/location/lakehouse.location';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(LakehouseLocation)
})
export class LakehouseLocationAdapter extends FileLocationAdapter<LakehouseLocation, Model.DatasetLocation> {
    public _toResource(store: LakehouseLocation): Model.LakehouseLocation {
        const resource: Model.LakehouseLocation = {
            type: 'LakehouseLocation',
            fileName: ValueAdapter.toResource(store, LakehouseLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, LakehouseLocation.FOLDER_PATH) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.LakehouseLocation, owner: Named): LakehouseLocation {
        const model = Owned.create<LakehouseLocation>(LakehouseLocation.MODEL, owner);
        ValueAdapter.toModel(model, LakehouseLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, LakehouseLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
